import type { SVGProps} from 'react';
import { useId } from 'react';

export const Solana = (props: SVGProps<SVGSVGElement>) => {
  const id = useId();

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${id})`}>
        <path
          d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
          fill="#181B25"
        />
        <path
          d="M35.8764 30.057L31.9145 34.214C31.8284 34.3043 31.7241 34.3763 31.6083 34.4255C31.4925 34.4747 31.3676 34.5001 31.2414 34.5H12.46C12.3703 34.5 12.2827 34.4744 12.2077 34.4263C12.1328 34.3782 12.0738 34.3098 12.0381 34.2294C12.0024 34.149 11.9915 34.0601 12.0067 33.9737C12.0219 33.8873 12.0625 33.8071 12.1237 33.743L16.0886 29.586C16.1745 29.4959 16.2783 29.4241 16.3938 29.3749C16.5092 29.3257 16.6337 29.3002 16.7596 29.3H35.54C35.6296 29.3 35.7173 29.3256 35.7923 29.3737C35.8671 29.4218 35.9261 29.4902 35.962 29.5706C35.9976 29.6511 36.0085 29.7399 35.9933 29.8263C35.9781 29.9127 35.9375 29.9929 35.8764 30.057ZM31.9145 21.686C31.8284 21.5957 31.7241 21.5237 31.6083 21.4745C31.4925 21.4253 31.3676 21.3999 31.2414 21.4H12.46C12.3703 21.4 12.2827 21.4256 12.2077 21.4737C12.1328 21.5218 12.0738 21.5902 12.0381 21.6706C12.0024 21.751 11.9915 21.8399 12.0067 21.9263C12.0219 22.0127 12.0625 22.0929 12.1237 22.157L16.0886 26.314C16.1745 26.4041 16.2783 26.4759 16.3938 26.5251C16.5092 26.5743 16.6337 26.5998 16.7596 26.6H35.54C35.6296 26.6 35.7173 26.5744 35.7923 26.5263C35.8671 26.4782 35.9261 26.4098 35.962 26.3294C35.9976 26.249 36.0085 26.1601 35.9933 26.0737C35.9781 25.9873 35.9375 25.9071 35.8764 25.843L31.9145 21.686ZM12.46 18.7H31.2414C31.3676 18.7001 31.4925 18.6747 31.6083 18.6255C31.7241 18.5763 31.8284 18.5043 31.9145 18.414L35.8764 14.257C35.9375 14.1929 35.9781 14.1127 35.9933 14.0263C36.0085 13.9399 35.9976 13.851 35.962 13.7706C35.9261 13.6902 35.8671 13.6218 35.7923 13.5737C35.7173 13.5256 35.6296 13.5 35.54 13.5H16.7596C16.6337 13.5002 16.5092 13.5257 16.3938 13.5749C16.2783 13.6241 16.1745 13.6959 16.0886 13.786L12.1247 17.943C12.0636 18.007 12.023 18.0871 12.0077 18.1734C11.9925 18.2597 12.0033 18.3485 12.0389 18.4289C12.0745 18.5093 12.1333 18.5777 12.2081 18.6259C12.2829 18.674 12.3704 18.6998 12.46 18.7Z"
          fill="url(#paint0_linear_1065_54608)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1065_54608"
          x1="14.0259"
          y1="35.0005"
          x2="33.2401"
          y2="12.8611"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.08" stop-color="#9945FF" />
          <stop offset="0.3" stop-color="#8752F3" />
          <stop offset="0.5" stop-color="#5497D5" />
          <stop offset="0.6" stop-color="#43B4CA" />
          <stop offset="0.72" stop-color="#28E0B9" />
          <stop offset="0.97" stop-color="#19FB9B" />
        </linearGradient>
        <clipPath id={id}>
          <path
            d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
